/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Beweegthema_Not_In_LeerlijnInputs */

const nl_planning_api_errors_beweegthema_not_in_leerlijn = /** @type {(inputs: Planning_Api_Errors_Beweegthema_Not_In_LeerlijnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gekozen beweegthema hoort niet bij deze leerlijn.`)
};

/**

* @param {Planning_Api_Errors_Beweegthema_Not_In_LeerlijnInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_beweegthema_not_in_leerlijn = /** @type {((inputs?: Planning_Api_Errors_Beweegthema_Not_In_LeerlijnInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Beweegthema_Not_In_LeerlijnInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_beweegthema_not_in_leerlijn(inputs)
});
export { planning_api_errors_beweegthema_not_in_leerlijn as "planning.api_errors.beweegthema_not_in_leerlijn" }